import { gql } from '@apollo/client'

import { PageInfoFragment, UserFragment, OrganizationRBACFragment } from '../fragments'

export const USERS = gql`
  query users($input: UserFindInput, $pagination: PaginationInput!) {
    users(input: $input, pagination: $pagination) {
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        node {
          ...UserFragment
          organizationACL {
            ...OrganizationRBACFragment
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${UserFragment}
  ${OrganizationRBACFragment}
`

export const USER = gql`
  query user($id: ID!) {
    user(id: $id) {
      ...UserFragment
    }
  }
  ${UserFragment}
`

export const GET_USER_ACCESS_TOKEN = gql`
  query getUserAccessToken($input: UserGetAccessTokenInput!) {
    getUserAccessToken(input: $input)
  }
`

export const IS_EMAIL_AVAILABLE = gql`
  query isEmailAvailable($email: String!) {
    isEmailAvailable(email: $email)
  }
`
